import { putMypageNovelNovelIdStatus } from "src/api/v1/mypage/novel/[novel_id]/status/put"
import { MypageNovelNovelIdStatusPutInputModel } from "src/api/v1/mypage/novel/[novel_id]/status/PutInputModel"

export const updateNovelStatus = async (
  novelId: number,
  status: number,
): Promise<void> => {
  await putMypageNovelNovelIdStatus(
    new MypageNovelNovelIdStatusPutInputModel({
      novelId,
      status,
    }),
  )
}
